import { type NavigateFunction } from "react-router/dist/lib/hooks"
import { type Dispatch } from "redux"

import { request } from "../../../services/api.ts"
import { handleGetResponseData } from "../../../utils/handlers/handle-get-response-data"
import utils from "../../../utils/utils"
import type { UserInfo } from "../types/auth.types.ts"
import { isAdminAccount, signedInLanding } from "./signed-in-landing.ts"

interface HandlePostLoginNavigationParams {
  dispatch: Dispatch
  navigate: NavigateFunction
  userInfo?: UserInfo
  redirect?: string | null
}

export const handlePostLoginNavigation = async ({
  dispatch,
  navigate,
  userInfo,
  redirect = null
}: HandlePostLoginNavigationParams) => {
  if (redirect && !isAdminAccount(userInfo)) {
    let decodedNextUrl
    try {
      decodedNextUrl = decodeURIComponent(redirect)
    } catch (e) {
      console.error("Error decoding nextUrl:", e)
      decodedNextUrl = redirect
    }

    const responseData = await request.api.post(decodedNextUrl, {
      maxRedirects: 0,
      validateStatus: (status: number) => status >= 200 && status < 400
    })
    const responseOauth = handleGetResponseData(responseData)

    if (responseOauth?.data?.redirect_uri) {
      return dispatch(utils.goLink(responseOauth?.data?.redirect_uri) as any)
    }
  }

  navigate(signedInLanding(userInfo), { replace: true })
}
